import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "weightPerProduct", "costPerProduct", "totalCost", "overheadCost"]

  connect() {
    this.calculateTotalCost()
  }

  calculateTotalCost() {
    const quantity = parseFloat(this.quantityTarget.value) || 0
    const costPerProduct = parseFloat(this.costPerProductTarget.value) || 0

    // Calculate base total
    let total = quantity * costPerProduct

    // Add overhead costs
    this.overheadCostTargets.forEach(costField => {
      total += parseFloat(costField.value) || 0
    })

    // Update total cost field
    this.totalCostTarget.value = total.toFixed(2)
  }
} 